import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NoteForm } from 'src/app/classes/form-groups/note-form';
import { Note } from 'src/app/classes/models';
import { ComplianceSteps } from 'src/app/interfaces/compliance-steps';
import { AuthService } from 'src/app/services/auth.service';
import { NoteService } from 'src/app/services/note.service';
import { ToastService } from 'src/app/services/toast.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-compliance-note-modal',
  templateUrl: './compliance-note-modal.component.html',
  styleUrl: './compliance-note-modal.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ComplianceNoteModalComponent implements OnInit {
  constructor(
    private AuthService: AuthService,
    private NoteService: NoteService,
    private Modal: NgbActiveModal,
    private ToastService: ToastService,
    private UtilityService: UtilityService
  ) {}

  CompanyId?: number;
  VendorId?: number;
  ExemptVendorId?: number;
  ClientRegisteredVendorId?: number;

  @Input() Note?: Note;
  @Input() NoteId?: number;
  @Input() CurrentComplianceStep!: ComplianceSteps;

  ComplianceStepToTitleArrayHashMap: {
    [key in ComplianceSteps]: string[];
  } = {
    'Vendor Info': [
      'Business Information Edits',
      'Business information - Waive/cure'
    ],
    'Owner Info': [
      'Owner Information Edits',
      'Owner information - Waive/cure',
      ''
    ],
    'Trades & Licenses': [
      'Trade Information Edits',
      'Trade information - Waive/cure'
    ],
    Insurance: [
      'Insurance Information - Edits',
      'Insurance Information: Waive/Cure'
    ],
    'Final Review': []
  };

  NoteFormGroup = new NoteForm();

  getNoteTitles() {
    return Object.values(
      this.ComplianceStepToTitleArrayHashMap[this.CurrentComplianceStep]
    );
  }

  saveNote() {
    const errors = this.UtilityService.generateValidationErrorsObject(
      this.NoteFormGroup
    );

    if (errors) {
      throw this.ToastService.addErrorToast(
        'Error',
        'There is an error with one of the fields below.',
        { returnError: true }
      );
    }

    const Note: Note = this.NoteFormGroup.value;

    // At least 1 id field is required to be applied to the note.
    const IdFields: (keyof Note)[] = [
      'CompanyId',
      'VendorId',
      'ExemptVendorId',
      'ClientRegisteredVendorId',
      'UserId',
      'ticketId',
      'EmailId'
    ];

    const isIdFieldOnNote = !!IdFields.find((idField) => !!Note[idField]);

    if (!isIdFieldOnNote) {
      throw this.ToastService.addErrorToast(
        'Error',
        'There was an error saving the Note.',
        { returnError: true }
      );
    }

    this.Modal.close(Note);
  }

  close() {
    this.Modal.dismiss();
  }

  ngOnInit(): void {
    // Check if CurrentComplianceStep is missing and close modal after showing error
    if (!this.CurrentComplianceStep) {
      setTimeout(() => {
        this.ToastService.addErrorToast(
          'Error',
          'Missing compliance step information.'
        );
        this.Modal.dismiss();
      }, 0);
      return;
    }

    if (this.Note) {
      this.NoteFormGroup.patchValue(this.Note);
    } else {
      this.NoteFormGroup.patchValue({
        CompanyId: this.CompanyId,
        VendorId: this.VendorId,
        ClientRegisteredVendorId: this.ClientRegisteredVendorId,
        ExemptVendorId: this.ExemptVendorId
      });
    }

    if (this.NoteId) {
      this.NoteService.getNote(
        this.UtilityService.stringifyObjectsInQueryObject({
          id: this.NoteId
        })
      ).subscribe({
        next: (Note) => {
          this.NoteFormGroup.patchValue(Note);
          this.Note = Note;
        }
      });
    }
  }
}
